import React from "react";
import PropTypes from 'prop-types';
import ScopeTagSelection from './scope_tag_selection';
import ScopeLabelSelection from './scope_label_selection';
import ScopeSectionSelection from './scope_section_selection';
import ScopeCustomFieldSelection from './scope_custom_field_selection';

function TriggerSelection({ ruleType, updateScope, scope }) {
  if (ruleType.includes("Rule::Tag")) {
    return <ScopeTagSelection updateScope={updateScope} scope={scope} />;
  }
  if (ruleType.includes("Rule::Label")) {
    return <ScopeLabelSelection updateScope={updateScope} scope={scope} />;
  }
  if (ruleType.includes("Rule::Section")) {
    return <ScopeSectionSelection updateScope={updateScope} scope={scope} />;
  }
  if (ruleType.includes("Rule::CustomField")) {
    return <ScopeCustomFieldSelection updateScope={updateScope} scope={scope} />;
  }
}

TriggerSelection.propTypes = {
  ruleType: PropTypes.string.isRequired,
  updateScope: PropTypes.func.isRequired
};

export default TriggerSelection;
